export const HybridUseCase = {
    IOS_BOARD_LIST: 'HybridUseCase.IOS_BOARD_LIST',
    IOS_CANVAS: 'HybridUseCase.IOS_CANVAS',
    ANDROID_BOARD_LIST: 'HybridUseCase.ANDROID_BOARD_LIST',
    IPAD_OS: 'HybridUseCase.IPAD_OS',
};
